import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealth = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_493_9166)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.9999 29.3337L7.99987 26.667L1.3332 17.3337L7.99987 18.667M15.9999 29.3337L23.9999 26.667L30.6665 17.3337L23.9999 18.667M15.9999 29.3337L13.3332 16.0003M15.9999 29.3337L18.6665 16.0003M15.9999 29.3337L7.99987 18.667M15.9999 29.3337L23.9999 18.667M7.99987 18.667L6.66653 10.667L13.3332 16.0003M13.3332 16.0003L15.9999 2.66699L18.6665 16.0003M18.6665 16.0003L25.3332 10.667L23.9999 18.667M1 11.0003H1.05M31 11.0003H31.05",
			stroke: "#50E3C2",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_493_9166",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgHealth;
